import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import { EntitiesStructure } from 'common/types/Page'
import { BaseEntityWithChildIdsInterface } from 'common/types/entities/EntityInterface'
import { OldEntityWithChildIds } from 'common/types/entities/OldEntityInterface'
import { createAgreementFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-agreement'
import { createButtonFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-button'
import { createCustomLoginFromLibrary } from 'client/components/core/Sidebar/components/Toolbox/creators/create-custom-login'
import { createField } from 'client/components/entities/field-new/field-new'
import { createLatestBlogPostsCarousel } from 'client/pages/blog-page/entities/LatestBlogPostsCarousel'
import { createProduct } from 'client/pages/offer/entities/Product'
import { ColumnTypeEnum } from '../../common/components/entities/Column/enums/ColumnTypeEnum'
import { createCountdown } from '../components/core/Sidebar/components/Settings/entities/Countdown/utils/create-countdown'
import { createBulletList } from '../components/core/Sidebar/components/Settings/entities/NewBulletListSettings/utils/create-bullet-list'
import { createPriceElement } from '../components/core/Sidebar/components/Settings/entities/price-element-settings/utils/create-price-element'
import { createOrderBumpFromLibrary } from '../components/core/Sidebar/components/Toolbox/creators/create-order-bump'
import { createAudio } from '../components/entities/Audio/AudioNew'
import { createFacebookComments } from '../components/entities/FacebookComments/utils/create-facebook-comments'
import { createImage } from '../components/entities/Image/Image'
import { createLanguageSwitcher } from '../components/entities/LanguageSwitcher/NewLanguageSwitcher'
import { createHorizontalLine } from '../components/entities/NewHorizontalLine'
import { createOrderSummary } from '../components/entities/OfferThankYouOrderSummaryNew'
import { createPricePlanCalculator } from '../components/entities/PricePlanCalculator'
import { createRawHtml } from '../components/entities/RawHtml/NewRawHtml'
import { createShippingFees } from '../components/entities/ShippingFees'
import { createText } from '../components/entities/Text/Text'
import { createTwitterTweetButton } from '../components/entities/TwitterTweetButton/utils/create-twitter-tweet-button'
import { createVideo } from '../components/entities/VideoNew'
import LibraryElementEnum from '../enums/LibraryElementEnum'
import { createBlogCategoryDescription } from '../pages/blog-page/entities/BlogCategoryDescription'
import { createBlogCategoryTitle } from '../pages/blog-page/entities/BlogCategoryTitle'
import { createBlogLatestPosts } from '../pages/blog-page/entities/BlogLatestPosts'
import { createBlogPostListing } from '../pages/blog-page/entities/BlogPostListing'
import { createBlogContentPlaceholder } from '../pages/blog/entities/BlogContentPlaceholderNew'
import { createBlogPostCategories } from '../pages/blog/entities/BlogPostCategories'
import { createBlogPostContentPlaceholder } from '../pages/blog/entities/BlogPostContentPlaceholderNew'
import { createBlogPostDate } from '../pages/blog/entities/BlogPostDateNew'
import { createBlogPostImage } from '../pages/blog/entities/BlogPostImage'
import { createBlogPostTitle } from '../pages/blog/entities/BlogPostTItleNew'
import { createBreadcrumbs } from '../pages/blog/entities/Breadcrumbs'
import { createCustomerType } from '../pages/offer/entities/CustomerType'
import { createOfferPrice } from '../pages/offer/entities/OfferPrice'
import { createPaymentMethod } from '../pages/offer/entities/PaymentMethod'
import { createWebinarRegistrationDate } from '../pages/webinar-registration-page/entities/WebinarRegistrationDate'
import { createWebinarSessionDateTime } from '../pages/webinar-thank-you/entities/WebinarSessionDateTime'
import { createWebinarSessionLink } from '../pages/webinar-thank-you/entities/WebinarSessionLink'
import {
  createCalendarFromLibrary,
  createCarouselFromLibrary,
  createCheckboxFromLibrary,
  createContactUsFromLibrary,
  createContentBoxFromLibrary,
  createContentTableFromLibrary,
  createDefaultEntityStructure,
  createFaqFromLibrary,
  createHeadlineFromLibrary,
  createMenuFromLibrary,
  createOptInRecaptchaFromLibrary,
  createPaymentButtonFromLibrary,
  createRowFromLibrary,
  createSalesRedirectionButtonFromLibrary,
  createSectionFromLibrary,
  createSurveyFromLibrary,
  createUpsellAgreeButtonFromLibrary,
  createUpsellDisagreeButtonFromLibrary,
  createWebinarCallToActionFromLibrary,
  createWebinarSessionVideoFromLibrary,
} from './createStructureUtils'

export default function createLibraryElementStructure(
  libraryElementType: LibraryElementEnum,
  container: OldEntityWithChildIds | BaseEntityWithChildIdsInterface,
  locale: string,
  position = 0,
) {
  let structure: EntitiesStructure
  switch (libraryElementType) {
    case LibraryElementEnum.LibraryImage:
      structure = createDefaultEntityStructure(
        createImage,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryFaq:
      structure = createFaqFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryPricePlanCalculator:
      structure = createDefaultEntityStructure(
        createPricePlanCalculator,
        container,
        locale,
        position,
      )
      break

    case LibraryElementEnum.LibraryPriceElement:
      structure = createDefaultEntityStructure(
        createPriceElement,
        container,
        locale,
        position,
      )
      break

    case LibraryElementEnum.LibraryWebinarRegistrationDate:
      structure = createDefaultEntityStructure(
        createWebinarRegistrationDate,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryOrderSummary:
      structure = createDefaultEntityStructure(
        createOrderSummary,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryText:
      structure = createDefaultEntityStructure(
        createText,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryHeadline:
      structure = createHeadlineFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryCustomLogin:
      structure = createCustomLoginFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryBlogPostImage:
      structure = createDefaultEntityStructure(
        createBlogPostImage,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryContentTable:
      structure = createContentTableFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryContactUs:
      structure = createContactUsFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryBreadcrumbs:
      structure = createDefaultEntityStructure(
        createBreadcrumbs,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryCarousel:
      structure = createCarouselFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryBlogPostDate:
      structure = createDefaultEntityStructure(
        createBlogPostDate,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogPostListing:
      structure = createDefaultEntityStructure(
        createBlogPostListing,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogLatestPosts:
      structure = createDefaultEntityStructure(
        createBlogLatestPosts,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogPostTitle:
      structure = createDefaultEntityStructure(
        createBlogPostTitle,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibrarySurvey:
      structure = createSurveyFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryMenu:
      structure = createMenuFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryUpsellAgreeButton:
      structure = createUpsellAgreeButtonFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryUpsellDisagreeButton:
      structure = createUpsellDisagreeButtonFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogPostCategories:
      structure = createDefaultEntityStructure(
        createBlogPostCategories,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogContentPlaceholder:
      structure = createDefaultEntityStructure(
        createBlogContentPlaceholder,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogPostBody:
      structure = createDefaultEntityStructure(
        createBlogPostContentPlaceholder,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryVideo:
      structure = createDefaultEntityStructure(
        createVideo,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryWebinarSessionVideo:
      structure = createWebinarSessionVideoFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryWebinarCallToAction:
      structure = createWebinarCallToActionFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryHorizontalLine:
      structure = createDefaultEntityStructure(
        createHorizontalLine,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogCategoryTitle:
      structure = createDefaultEntityStructure(
        createBlogCategoryTitle,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryBlogCategoryDescription:
      structure = createDefaultEntityStructure(
        createBlogCategoryDescription,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryWebinarSessionLink:
      structure = createDefaultEntityStructure(
        createWebinarSessionLink,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryWebinarSessionDateTime:
      structure = createDefaultEntityStructure(
        createWebinarSessionDateTime,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryOfferPrice:
      structure = createDefaultEntityStructure(
        createOfferPrice,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryProduct:
      structure = createDefaultEntityStructure(
        createProduct,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryOrderBump:
      structure = createOrderBumpFromLibrary(container, locale, position)
      break
    case LibraryElementEnum.LibraryLatestBlogPostsCarousel:
      structure = createDefaultEntityStructure(
        createLatestBlogPostsCarousel,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryField:
      structure = createDefaultEntityStructure(
        createField,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryAudio:
      structure = createDefaultEntityStructure(
        createAudio,
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibrarySalesRedirectionButton:
      structure = createSalesRedirectionButtonFromLibrary(
        container,
        locale,
        position,
      )
      break
    case LibraryElementEnum.LibraryFacebookComments: {
      structure = createDefaultEntityStructure(
        createFacebookComments,
        container,
        locale,
        position,
      )
      break
    }
    case LibraryElementEnum.LibraryOptInRecaptcha: {
      structure = createOptInRecaptchaFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryTwitterTweetButton: {
      structure = createDefaultEntityStructure(
        createTwitterTweetButton,
        container,
        locale,
        position,
      )
      break
    }
    case LibraryElementEnum.LibraryCountdown: {
      structure = createDefaultEntityStructure(
        createCountdown,
        container,
        locale,
        position,
      )
      break
    }
    case LibraryElementEnum.LibraryLanguageSwitcher: {
      structure = createDefaultEntityStructure(
        createLanguageSwitcher,
        container,
        locale,
        position,
      )
      break
    }
    case LibraryElementEnum.LibraryCustomerType: {
      structure = createDefaultEntityStructure(
        createCustomerType,
        container,
        locale,
        position,
      )
      break
    }
    case LibraryElementEnum.LibraryContentBox: {
      structure = createContentBoxFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryPaymentMethod: {
      structure = createDefaultEntityStructure(
        createPaymentMethod,
        container,
        locale,
        position,
      )
      break
    }
    case LibraryElementEnum.LibraryRow: {
      structure = createRowFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryRawHTML: {
      structure = createDefaultEntityStructure(
        createRawHtml,
        container,
        locale,
        position,
      )
      break
    }
    case LibraryElementEnum.LibraryCheckbox: {
      structure = createCheckboxFromLibrary(container, locale, position)
      break
    }

    case LibraryElementEnum.LibraryBulletList: {
      structure = createDefaultEntityStructure(
        createBulletList,
        container,
        locale,
        position,
      )
      break
    }

    case LibraryElementEnum.LibraryCalendar: {
      structure = createCalendarFromLibrary(container, locale, position)
      break
    }

    case LibraryElementEnum.LibraryColumn6: {
      structure = createRowFromLibrary(
        container,
        locale,
        position,
        ColumnTypeEnum.COLUMN_6,
      )
      break
    }

    case LibraryElementEnum.LibraryColumn4: {
      structure = createRowFromLibrary(
        container,
        locale,
        position,
        ColumnTypeEnum.COLUMN_4,
      )
      break
    }

    case LibraryElementEnum.LibraryColumn3: {
      structure = createRowFromLibrary(
        container,
        locale,
        position,
        ColumnTypeEnum.COLUMN_3,
      )
      break
    }
    case LibraryElementEnum.LibrarySection: {
      structure = createSectionFromLibrary(container, position)
      break
    }
    case LibraryElementEnum.LibraryShippingFees: {
      structure = createDefaultEntityStructure(
        createShippingFees,
        container,
        locale,
        position,
      )
      break
    }
    case LibraryElementEnum.LibraryPaymentButton: {
      structure = createPaymentButtonFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryAgreement: {
      structure = createAgreementFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryButton: {
      structure = createButtonFromLibrary(container, locale, position)
      break
    }
    case LibraryElementEnum.LibraryOpenUrlButton: {
      structure = createButtonFromLibrary(container, locale, position, {
        action: ButtonActionTypeEnum.OpenUrl,
      })
      break
    }
    default:
      throw new Error('unknown library type')
  }
  return structure
}
